import thunk from 'redux-thunk';

export default [thunk];



/** WEBPACK FOOTER **
 ** ./~/roc-package-web-app-react/app/shared/flux/middlewares/index.js
 **/